import { QueryClient, UseQueryResult } from "react-query";
import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import { ApiAssociatedProgramActivityListResponse } from "shared/types/ApiAssociatedProgramActivityListResponse";

export function getActivitiesForAdminQueryKey(programParticipantId?: string) {
  return getApiQueryKey(MyExpApi.ASSOCIATED_PROGRAM_ACTIVITY_LIST_BY_ACTIVITY_ADMIN_ID, {
    params: {
      activityAdminId: programParticipantId
    }
  });
}

export function useGetAssociatedProgramsActivities({
  programParticipantId
}: {
  programParticipantId?: string;
}): UseQueryResult<Array<ApiAssociatedProgramActivityListResponse>> {
  return useGetApiData<Array<ApiAssociatedProgramActivityListResponse>>(
    MyExpApi.ASSOCIATED_PROGRAM_ACTIVITY_LIST_BY_ACTIVITY_ADMIN_ID,
    {
      params: {
        activityAdminId: programParticipantId
      }
    },
    {
      enabled: Boolean(programParticipantId)
    }
  );
}

export function updateActivityListForAdminWithChanges(
  queryClient: QueryClient,
  programParticipantId: string,
  dataToUpdate: ApiAssociatedProgramActivityListResponse,
  invalidateList?: boolean
) {
  if (invalidateList) queryClient.invalidateQueries(getActivitiesForAdminQueryKey(programParticipantId));
  else
    queryClient.setQueryData(
      getActivitiesForAdminQueryKey(programParticipantId),
      (prevData: Array<ApiAssociatedProgramActivityListResponse> = []) => {
        return (prevData as Array<ApiAssociatedProgramActivityListResponse>).map(item => {
          return item.id === dataToUpdate.id ? { ...dataToUpdate } : { ...item };
        });
      }
    );
}
